import { assetsApi } from "src/api/assets";
import { slice } from "src/slices/assets";
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as XLSX from "xlsx";

const getItems = (fetchPath) => async (dispatch) => {
  try {
    dispatch(slice.actions.setItems([]));
    dispatch(slice.actions.setItemsLoading(true));

    const items = await assetsApi.getItems(fetchPath);

    dispatch(slice.actions.setItems(items));
    dispatch(slice.actions.setItemsLoading(false));
  } catch (err) {
    console.log(err);
  }
};

const createFolder = (folderName) => async (dispatch) => {
  try {
    await assetsApi.createFolder(folderName);
  } catch (err) {
    console.log(err);
  }
};

const viewItem = (filePath) => async () => {
  try {
    const fileUrl = await assetsApi.viewItem(filePath);

    // Open the file in a new tab
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  } catch (err) {
    console.error("Error opening file:", err);
  }
};

const deleteFolder = (folderPath) => async (dispatch) => {
  try {
    dispatch(slice.actions.setItemDeleting(true));

    await assetsApi.deleteFolder(folderPath);

    dispatch(slice.actions.setItemDeleting(false));
  } catch (err) {
    console.log(err);
  }
};

const deleteItem = (filePath) => async (dispatch) => {
  try {
    dispatch(slice.actions.setItemDeleting(true));

    await assetsApi.deleteItem(filePath);

    // Trigger Close Modal
    dispatch(slice.actions.deleteItemModalReset());

    dispatch(slice.actions.setItemDeleting(false));
  } catch (err) {
    console.log(err);
  }
};

// Delete Multiple Selected Items
const deleteMultipleSelectedItems = (filesPathArray) => async (dispatch) => {
  try {
    dispatch(slice.actions.setMultipleItemsDeleting(true));

    await assetsApi.deleteMultipleItems(filesPathArray);

    // Trigger Close Modal
    dispatch(slice.actions.deleteMultipleSelectedItemsModalReset());

    dispatch(slice.actions.setMultipleItemsDeleting(false));
  } catch (err) {
    console.log(err);
  }
};

// Upload Files
const uploadFiles = createAsyncThunk(
  "assets/uploadFiles",
  async (selectedFilesForUpload, { rejectWithValue }) => {
    try {
      const response = await assetsApi.uploadFiles(selectedFilesForUpload);
      return response;
    } catch (error) {
      throw rejectWithValue(error); // Return error payload
    }
  }
);

// Upload Files Errors Reset
const uploadFilesErrorReset = () => async (dispatch) => {
  dispatch(slice.actions.uploadFilesErrorsReset());
};

// Close Add Item Modal Reset
const closeAddItemModalReset = () => async (dispatch) => {
  dispatch(slice.actions.closeAddItemModalReset());
};

// Close Delete Folder / Item Modal Reset (Single)
const closeDeleteItemModalReset = () => async (dispatch) => {
  dispatch(slice.actions.closeDeleteItemModalReset());
};

// Close Delete Multiple Selected Items Modal Reset
const closeDeleteMultipleSelectedItemsModalReset = () => async (dispatch) => {
  dispatch(slice.actions.closeDeleteMultipleSelectedItemsModalReset());
};

// Used for Export Excel Assets Files from a Folder
const exportFilesToExcel = (fetchPath) => async (dispatch) => {
  const result = await assetsApi.exportExcelFiles(fetchPath);

  // Create a worksheet from the data
  const ws = XLSX.utils.json_to_sheet(result.items);

  // Create a workbook with the worksheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  // Convert the workbook to an array buffer
  const excelFile = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  // Convert the array buffer to a blob
  const blob = new Blob([excelFile], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Create a URL for the blob
  const url = URL.createObjectURL(blob);

  // Create a link element to trigger the download
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${result.details.path}.xlsx`);

  // Trigger a click event to start the download
  link.click();

  // Clean up by revoking the URL object
  URL.revokeObjectURL(url);
};

// Spaces Api History Log
const getSpacesApiHistoryLog = () => async (dispatch) => {
  dispatch(slice.actions.spacesApiHistoryLogLoading());
  const response = await assetsApi.getSpacesApiHistory();
  dispatch(slice.actions.spacesApiHistoryLogReceived(response));
};

export const thunks = {
  getItems,
  createFolder,
  viewItem,

  // Delete
  deleteFolder,
  deleteItem,
  deleteMultipleSelectedItems,
  closeDeleteItemModalReset,
  closeDeleteMultipleSelectedItemsModalReset,

  //
  // Upload Files
  //
  uploadFiles,
  uploadFilesErrorReset,
  closeAddItemModalReset,

  //
  // Export Excel
  //
  exportFilesToExcel,

  //
  // Spaces Api History Log
  //
  getSpacesApiHistoryLog,
};
